import { TranslationChunksConfig } from '@spartacus/core'

export const mbChunks: TranslationChunksConfig = {
  common: [
    'httpHandlers',
    'pageMetaResolver',
    'navigation'
  ],
  mbCart: [
    'mbcart',
    'addToCartPopup',
    'submitBox',
    'payment'
  ],
  mbProduct: [
    'mbproduct',
    'mbProductTabs',
    'productListComponent'
  ],
  mbProductLine: [
    'pdpProductLine',
    'cartProductLine',
    'emptyCart',
    'pdpWishList'
  ],
  mbLoginRegisterPage: [
    'mbLogin',
    'mbRegister'
  ],
  mbCommon: [
    'mbcommon',
    'formValidationErrors',
    'addressesValidationErrors'
  ],
  mbForms: [
    'registrationConfirmation',
    'registrationProgress',
    'countrySelector',
    'quoteInfo',
    'contact',
    'address',
    'review'
  ],
  mbCmsComponents: [
    'shared',
    'videoLibrary',
    'iqView',
    'jobSearch',
    'cmsList',
    'ucBlockedContent'
  ],
  mbCheckout: [
    'checkoutCommon',
    'navigationPage',
    'checkoutProgressBar',
    'orderConfirmation',
    'checkoutErrors'
  ],
  mbSearch: [
    'mainSearchBox',
    'searchResultItem',
    'searchResultItemCms',
    'searchFilterPane',
    'searchHeading',
    'homepageSearch'
  ],
  mbCountry: [
    'countryBar'
  ],
  mbMyAccount: [
    'welcome'
  ],
  mbUniversity: [
    'trainingDescription',
    'trainingLocations',
    'trainingObjectives',
    'trainingRegistration',
    'trainingUsp',
    'trainingItem',
    'trainingCategories',
    'trainingList'
  ],
  mbPoUpload: [
    'poUploadHeadline',
    'poUploadForm',
    'poUploadCart'
  ]
}
